import React, { useEffect, useRef, useState } from "react";
import "./Settings2.css";
import back from "../../imgs/backexam.png";
import milkcan from "../../imgs/milkcan.png";
import farmer from "../../imgs/farmer.png";
import khadya from "../../imgs/khadya.png";
import cash from "../../imgs/cash.png";
import time from "../../imgs/time.png";
import weight from "../../imgs/wightmachine.png";

import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { UilEditAlt, UilTrash, UilSetting } from "@iconscout/react-unicons";
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from "../../Context/Globalcontext";
import { useTranslation } from "react-i18next";
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";

const Settings = (props) => {
  const { t, i18n } = useTranslation();
  const inputRefs = useRef([]);
  const [newedit, setNewedit] = useState("new");
  const [input, setInput] = useState({
    suchana: "",
    lpoints: "",
    round: "",
    custbill: "",
    avg: "",
    weightcomm: "",
    weightbrate: "",
    fatcomm: "",
    fatbrate: "",
    itrmainname: "",
    sanghkname: "",
  });
  const [DataSource, setDataSource] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [khnames, setKhnames] = useState([]);
  const [round, setRound] = useState("on");
  const [sankprint, setSankprint] = useState("on");

  const [value, setValue] = useState("");
  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);

  const [yatra, setYatra] = useState("On");
  const [ratibedit, setRatibedit] = useState("Off");
  const [ratibdelete, setRatibdelete] = useState("Off");

  const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
  const isKannada = (lang || "").toLowerCase().startsWith("kn");

  useEffect(() => {
    const styleId = "settings2-kannada-font-style";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.innerHTML = `
        @font-face {
          font-family: 'NotoSansKannadaCustom';
          src: url(${NotoSansKannada}) format('truetype');
          font-weight: normal;
          font-style: normal;
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  const fontStyle = {
    fontFamily: isKannada ? "NotoSansKannadaCustom, sans-serif" : undefined,
  };

  const handleToggleyatra = () => {
    setYatra(yatra === "On" ? "Off" : "On");
  };

  const handleTimeChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const handleToggle = () => {
    setRound(round === "on" ? "off" : "on");
  };

  const handleTogglesankprint = () => {
    setSankprint(sankprint === "on" ? "off" : "on");
  };

  const convertTo12Hour = (time) => {
    if (!time) return "";
    let [hours, minutes] = time.split(":");
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${period}`;
  };

  function handleEnterKey(event, currentIndex) {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      let nextIndex = null;
      nextIndex = currentIndex + 1;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
    if (
      event.key === "Backspace" &&
      ((event.target.tagName === "INPUT" && event.target.value === "") ||
        (event.target.tagName === "SELECT" &&
          event.target.name === "type" &&
          event.target.value === "प्रकार निवडा"))
    ) {
      event.preventDefault();

      let prevIndex = currentIndex - 1;
      while (prevIndex >= 0) {
        const prevElement = inputRefs.current[prevIndex];
        if (prevElement) {
          if (
            (prevElement.tagName === "INPUT" ||
              prevElement.tagName === "SELECT") &&
            prevElement !== event.target
          ) {
            prevElement.focus();
            break;
          } else {
            prevIndex--;
          }
        } else {
          prevIndex--;
        }
      }
    }
  }

  const handleChange = async (event) => {
    const name = event.target.name;
    let valuecurrent = "";
    valuecurrent = event.target.value;
    setInput((value) => ({ ...value, [name]: valuecurrent }));
  };

  useEffect(() => {
    setInput((prevInput) => ({
      ...prevInput,
      suchana: localStorage.getItem("suchana"),
      lpoints: localStorage.getItem("lpoints"),
      custbill: localStorage.getItem("custbill"),
      avg: localStorage.getItem("avg"),
      weightcomm: localStorage.getItem("weightcomm"),
      weightbrate: localStorage.getItem("weightbrate"),
      fatcomm: localStorage.getItem("fatcomm"),
      fatbrate: localStorage.getItem("fatbrate"),
      itrmainname: localStorage.getItem("itrmainname"),
      sanghkname: localStorage.getItem("sanghkname"),
    }));
    setRound(localStorage.getItem("round"));
    setSankprint(localStorage.getItem("sankprint"));
  }, []);

  function handleEnterKeybutton(event, currentIndex) {
    if (event.key === "Enter") {
      event.preventDefault();
      updatesuchana();
      let nextIndex = null;
      if (currentIndex === 0) {
        if (input.name !== "") {
          nextIndex = currentIndex + 1;
        } else {
          nextIndex = currentIndex;
        }
      } else {
        nextIndex = currentIndex + 1;
      }
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    } else if (event.key === "Backspace") {
      if (event.target.tagName === "BUTTON") {
        if (inputRefs.current[4]) {
          inputRefs.current[4].focus();
        }
      }
    }
  }

  async function updatesuchana() {
    localStorage.setItem("lpoints", input.points);
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios
      .post("https://excellentdairy.com/dairy/php/cust/updatesuchana.php", {
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
        suchana: input.suchana,
        lpoints: input.lpoints,
        round: round,
        sankprint: sankprint,
        custbill: input.custbill,
        weightcomm: input.weightcomm,
        weightbrate: input.weightbrate,
        fatcomm: input.fatcomm,
        fatbrate: input.fatbrate,
        avg: input.avg,
        itrmainname: input.itrmainname,
        sanghkname: input.sanghkname,
      })
      .then(function sample(response) {
        if (response.data) {
          if (response.data === "updated!") {
            notify(t("settings2.messages.updated"));
            localStorage.setItem("suchana", input.suchana);
            localStorage.setItem("lpoints", input.lpoints);
            localStorage.setItem("round", round);
            localStorage.setItem("sankprint", sankprint);
            localStorage.setItem("custbill", input.custbill);
            localStorage.setItem("avg", input.avg);
            localStorage.setItem("weightcomm", input.weightcomm);
            localStorage.setItem("weightbrate", input.weightbrate);
            localStorage.setItem("fatcomm", input.fatcomm);
            localStorage.setItem("fatbrate", input.fatbrate);
            localStorage.setItem("itrmainname", input.itrmainname);
            localStorage.setItem("sanghkname", input.sanghkname);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  return (
    <div className="khadyamain" style={fontStyle}>
      <div className="firstrowkhadya">
        <img onClick={props.visibility} className="back" src={back} alt="" />
        <div className="colmainkhadya">
          <div className="firstrow2">
            <div className="rowsank">
              <div className="mb-2">
                <span className="subheadsank" style={fontStyle}>
                  {t("settings2.title")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="linekh" />
      <div className="row1kh"></div>

      <div className="row1settings">
        <div className="mb-2">
          <span className="subheadsank" style={fontStyle}>
            {t("settings2.sections.billPrintInstruction")}
          </span>
          <input
            type="text"
            onKeyDown={(e) => handleEnterKey(e, 0)}
            ref={(ref) => (inputRefs.current[0] = ref)}
            className={"form-control"}
            autoComplete="off"
            id="suchana"
            name="suchana"
            value={input.suchana}
            onChange={handleChange}
            style={fontStyle}
          ></input>
        </div>
      </div>

      <div className="mb-2">
        <span className="subheadsank" style={fontStyle}>
          {t("settings2.sections.automationSettings")}
        </span>
      </div>

      <div className="row1settings">
        <div className="autoboxsettings2">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.weightComPort")}
          </span>
          <select
            onKeyDown={(e) => handleEnterKey(e, 2)}
            ref={(ref) => (inputRefs.current[2] = ref)}
            list="encodings"
            autoComplete="off"
            className={
              newedit === "new"
                ? "form-control inputfont"
                : "form-control inputfont editmode"
            }
            id="weightcomm"
            name="weightcomm"
            value={input.weightcomm}
            onChange={handleChange}
            style={fontStyle}
          >
            <option key={0} value="निवडा">
              {t("settings2.common.select")}
            </option>
            <option key={1} value="1">1</option>
            <option key={2} value="2">2</option>
            <option key={3} value="3">3</option>
            <option key={4} value="4">4</option>
            <option key={5} value="5">5</option>
            <option key={6} value="6">6</option>
            <option key={7} value="7">7</option>
            <option key={8} value="8">8</option>
            <option key={9} value="9">9</option>
            <option key={10} value="10">10</option>
          </select>
        </div>

        <div className="autoboxsettings2">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.weightBaudRate")}
          </span>
          <select
            onKeyDown={(e) => handleEnterKey(e, 2)}
            ref={(ref) => (inputRefs.current[2] = ref)}
            list="encodings"
            autoComplete="off"
            className={
              newedit === "new"
                ? "form-control inputfont"
                : "form-control inputfont editmode"
            }
            id="weightbrate"
            name="weightbrate"
            value={input.weightbrate}
            onChange={handleChange}
            style={fontStyle}
          >
            <option key={0} value="निवडा">
              {t("settings2.common.select")}
            </option>
            <option key={1200} value="1200">1200</option>
            <option key={2400} value="2400">2400</option>
            <option key={9600} value="9600">9600</option>
          </select>
        </div>

        <div className="autoboxsettings2">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.fatComPort")}
          </span>
          <select
            onKeyDown={(e) => handleEnterKey(e, 2)}
            ref={(ref) => (inputRefs.current[2] = ref)}
            list="encodings"
            autoComplete="off"
            className={
              newedit === "new"
                ? "form-control inputfont"
                : "form-control inputfont editmode"
            }
            id="fatcomm"
            name="fatcomm"
            value={input.fatcomm}
            onChange={handleChange}
            style={fontStyle}
          >
            <option key={0} value="निवडा">
              {t("settings2.common.select")}
            </option>
            <option key={1} value="1">1</option>
            <option key={2} value="2">2</option>
            <option key={3} value="3">3</option>
            <option key={4} value="4">4</option>
            <option key={5} value="5">5</option>
            <option key={6} value="6">6</option>
            <option key={7} value="7">7</option>
            <option key={8} value="8">8</option>
            <option key={9} value="9">9</option>
            <option key={10} value="10">10</option>
          </select>
        </div>

        <div className="autoboxsettings2">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.fatBaudRate")}
          </span>
          <select
            onKeyDown={(e) => handleEnterKey(e, 2)}
            ref={(ref) => (inputRefs.current[2] = ref)}
            list="encodings"
            autoComplete="off"
            className={
              newedit === "new"
                ? "form-control inputfont"
                : "form-control inputfont editmode"
            }
            id="fatbrate"
            name="fatbrate"
            value={input.fatbrate}
            onChange={handleChange}
            style={fontStyle}
          >
            <option key={0} value="निवडा">
              {t("settings2.common.select")}
            </option>
            <option key={1200} value="1200">1200</option>
            <option key={2400} value="2400">2400</option>
            <option key={9600} value="9600">9600</option>
          </select>
        </div>

        <div className="autoboxsettings">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.sanghDeductionName")}
          </span>
          <input
            type="text"
            onKeyDown={(e) => handleEnterKey(e, 0)}
            ref={(ref) => (inputRefs.current[0] = ref)}
            className={"form-control"}
            autoComplete="off"
            id="sanghkname"
            name="sanghkname"
            value={input.sanghkname}
            onChange={handleChange}
            style={fontStyle}
          ></input>
        </div>
      </div>

      <div className="row1settings">
        <div className="autoboxsettings">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.literPoints")}
          </span>
          <input
            type="text"
            onKeyDown={(e) => handleEnterKey(e, 0)}
            ref={(ref) => (inputRefs.current[0] = ref)}
            className={"form-control"}
            autoComplete="off"
            id="lpoints"
            name="lpoints"
            value={input.lpoints}
            onChange={handleChange}
            style={fontStyle}
          ></input>
        </div>

        <div className="autoboxsettings">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.otherDeductionName")}
          </span>
          <input
            type="text"
            onKeyDown={(e) => handleEnterKey(e, 0)}
            ref={(ref) => (inputRefs.current[0] = ref)}
            className={"form-control"}
            autoComplete="off"
            id="itrmainname"
            name="itrmainname"
            value={input.itrmainname}
            onChange={handleChange}
            style={fontStyle}
          ></input>
        </div>

        <div className="autoboxsettings2">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.customerAppBillDesign")}
          </span>
          <select
            onKeyDown={(e) => handleEnterKey(e, 2)}
            ref={(ref) => (inputRefs.current[2] = ref)}
            list="encodings"
            autoComplete="off"
            className={
              newedit === "new"
                ? "form-control inputfont"
                : "form-control inputfont editmode"
            }
            id="custbilltype"
            name="custbill"
            value={input.custbill}
            onChange={handleChange}
            style={fontStyle}
          >
            <option key={0} value="डिझाईन निवडा">
              {t("settings2.common.selectDesign")}
            </option>
            <option key={1} value="1">1</option>
            <option key={2} value="2">2</option>
          </select>
        </div>

        <div className="autoboxsettings2">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.averageBillPrint")}
          </span>
          <select
            onKeyDown={(e) => handleEnterKey(e, 2)}
            ref={(ref) => (inputRefs.current[2] = ref)}
            list="encodings"
            autoComplete="off"
            className={
              newedit === "new"
                ? "form-control inputfont"
                : "form-control inputfont editmode"
            }
            id="avg"
            name="avg"
            value={input.avg}
            onChange={handleChange}
            style={fontStyle}
          >
            <option key={0} value="निवडा">
              {t("settings2.common.select")}
            </option>
            <option key={1} value="On">
              {t("settings2.common.on")}
            </option>
            <option key={2} value="Off">
              {t("settings2.common.off")}
            </option>
          </select>
        </div>

        <div className="autoboxsettings3">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.adaRound")}
          </span>
          <label className="switch">
            <input
              type="checkbox"
              checked={round === "on"}
              onChange={handleToggle}
            />
            <span className="slider round"></span>
          </label>
        </div>

        <div className="autoboxsettings3">
          <span className="subheadmobileuser2" style={fontStyle}>
            {t("settings2.labels.sankalanPrint")}
          </span>
          <label className="switch">
            <input
              type="checkbox"
              checked={sankprint === "on"}
              onChange={handleTogglesankprint}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div className="linekh" />

      <div className="row1kh">
        <div className="mb-2">
          <button
            onClick={updatesuchana}
            onKeyDown={(e) => handleEnterKeybutton(e, 0)}
            ref={(ref) => (inputRefs.current[3] = ref)}
            type="submit"
            className="btn btn-primary mx-1 sanksmall"
            style={fontStyle}
          >
            {t("settings2.buttons.updateSettings")}
          </button>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Settings;